module.exports = __webpack_public_path__ + "static/media/angler.cbdaba74.jpg";